import { createNgModule, Injectable, Injector, NgModuleRef } from '@angular/core';

export interface LightboxAlbum {
  src: string;
  caption?: string;
  thumb: string;
  downloadUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class LazyLightboxService {
  private moduleRef: NgModuleRef<any> | null = null;
  private lightbox: any;
  private loading: Promise<any> | null = null;

  constructor(private readonly injector: Injector) {}

  async open(
    album: Array<LightboxAlbum>,
    currentIndex = 0,
    options?: {},
  ): Promise<void> {
    const lightbox = await this.getLightbox();
    lightbox.open(album, currentIndex, options);
  }

  async close(): Promise<void> {
    const lightbox = await this.getLightbox();
    lightbox.close();
  }

  private getLightbox(): Promise<any> {
    if (this.lightbox) {
      return Promise.resolve(this.lightbox);
    }

    if (!this.loading) {
      this.loading = import('ngx-lightbox').then(
        ({ Lightbox, LightboxModule }) => {
          this.moduleRef = createNgModule(LightboxModule, this.injector);
          this.lightbox = this.moduleRef.injector.get(Lightbox);
          return this.lightbox;
        },
      );
    }

    return this.loading;
  }
}
